import { FunctionComponent } from "react";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

interface ITableHeadersProps {
  columns: string[];
  sortColumn: string | null;
  sortDirection: "asc" | "desc" | null;
  onSort: (columnName: string) => void;
}

const TableHeaders: FunctionComponent<ITableHeadersProps> = ({
  columns,
  sortColumn,
  sortDirection,
  onSort,
}) => (
  <thead className="bg-gradient-to-r from-primary to-primary/80 text-white uppercase tracking-wide">
    <tr>
      {columns.map((col, index) => {
        const isSorted = sortColumn === col;
        const SortIcon =
          sortDirection === "asc"
            ? ArrowUp
            : sortDirection === "desc"
            ? ArrowDown
            : ArrowUpDown;

        return (
          <th
            key={index}
            className={`py-3 px-4 font-semibold cursor-pointer select-none transition-all ${
              isSorted ? "text-blue-200" : "hover:text-blue-100"
            }`}
            onClick={() => onSort(col)}
          >
            <div className="flex items-center gap-2">
              <span>{col}</span>
              <SortIcon size={16} className="transition-transform duration-300" />
            </div>
          </th>
        );
      })}
    </tr>
  </thead>
);

export default TableHeaders;
